<template>
<div>
  <div class="content has-text-centered has-background-white">
    <img src="../assets/mperaheader.png" height="100px">
  </div>

  <section>
    <div class="container">
        <b-message id="msg-top" type="is-danger" style="display: none">
          <li v-for="message in messages">
            {{ message }}
          </li>
        </b-message>
    </div>
  </section>

  <form id="mainpage" @submit.prevent="processPage1">

    <br>
    <div class="container">
      <div class="box">
        <div class="content has-text-centered">
          <h5 class="title is-5">Member Information</h5>
        </div>
        <table>
          <tr style="text-align: left;">
            <td style="text-align: left; width: 40%">
              <div class="box">
                <div class="field is-horizontal">
                  <div class="field-label">
                    <label class="label">Member Birth Date</label>
                  </div>
                  <!-- <p class="control is-expanded"> -->
                  <p class="control has-text-left">
                    <b-datepicker id="memberdob" v-model="calcData.memberdob" placeholder="MM/DD/YYYY" icon="calendar-today" editable></b-datepicker>
                  </p>
                </div> <!-- end of box-->
              </div>
            </td>
            <td style="width: 20%">
            <td style="text-align: left; width: 40%">
              <template v-if="calcData.retsys === 'PERS'">
                <div class="box">
                  <div class="field is-horizontal">
                    <div class="field-label">
                      <label class="label">Contingent Annuitant DOB</label>
                    </div>
                    <!-- <p class="control is-expanded"> -->
                    <p class="control">
                      <b-datepicker id="benedob" v-model="calcData.benedob" placeholder="MM/DD/YYYY" icon="calendar-today" editable></b-datepicker>
                    </p>
                  </div>
                </div>
              </template>
            </td>
          </tr>

          <tr><br></tr>
          <tr style="text-align: left;">
            <td style="width: 40%">
              <p>In order to determine retirement eligibility, we need to collect your birth date.</p>
            </td>
            <td style="width: 20%"></td>
            <td style="width: 40%">
              <template v-if="calcData.retsys === 'PERS' && calcData.benedob">
                <div class="field">
                  <b-checkbox id="chkspouse" v-model="calcData.chkspouse">Contingent Annuitant is spouse</b-checkbox>
                </div>
                <p>In order to determine additional retirement options, we need to collect information about your contingent annuitant. (Optional)</p>
              </template>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- ============================================================================================================= -->
    <!-- ============================================================================================================= -->

    <br>
    <div class="container">
      <div class="box">
        <div class="content has-text-centered">
          <h5 class="title is-5">Termination Information</h5>
        </div>
        <div class="box">
          <p>Enter at what point you want benefit estimate based: (A termination date, at a certain age or when a certain amount of service credit has been reached)</p>
          <br>


          <table class="table"  style="width: 100%">
            <div class="content">
              <tr>
                <td style="width: 40%">
                  <div class="field is-grouped">
                    <label class="radio">
                      <input type="radio" id="chkTerm" name="question" value="T" v-model="calcData.checkedOption">
                      Termination Date
                    </label>
                    <label class="radio">
                      <input type="radio" id="chkAge" name="question" value="A" v-model="calcData.checkedOption">
                      Age
                    </label>
                    <label class="radio">
                      <input type="radio" id="chkServCredit" name="question" value="Y" v-model="calcData.checkedOption">
                      Years of Service Credit
                    </label>
                  </div>
                </td>
                <td style="width: 60%">
                  <div v-if="calcData.checkedOption==='T'" id=dvTermDate class="field is-grouped">
                    <div class="field-label">
                      <label class="label">Termination Date</label>
                    </div>
                    <p class="control is-expanded">
                      <b-datepicker id="term" v-model="calcData.at_termdate" placeholder="MM/DD/YYYY" icon="calendar-today" editable required></b-datepicker>
                    </p>
                  </div>
                  <div v-if="calcData.checkedOption==='A'" id=dvAgeBlock class="field is-grouped">
                    <div class="field-label">
                      <label class="label">Age</label>
                    </div>
                    <p class="control is-expanded">
                      <b-input type="number" placeholder="Age" name="at_age" id="at_age" min="1" max="110"  v-model="calcData.at_age"></b-input>
                    </p>
                  </div>
                  <div v-if="calcData.checkedOption==='Y'" id=dvServCreditBlock class="field is-grouped">
                    <div class="field-label">
                      <label class="label">Amt. of Service Credit (Years)</label>
                    </div>
                    <p class="control is-expanded">
                      <b-input type="number" placeholder="Years" name="at_scyears" id="at_scyears" min="1" max="110"  v-model="calcData.at_scyears"></b-input>
                    </p>
                  </div>
                </td>
              </tr>
            </div>
          </table>
          <div class="container">
          </div>
          <div class="field">
            <b-checkbox>Check if you wish to draw retirement benefits at a date beyond your termination date</b-checkbox>
          </div>
        </div>
      </div>
    </div>
    <br>
    <!-- ============================================================================================================= -->
    <!-- ============================================================================================================= -->

    <div class="container">
      <div class="box">
        <div class="content has-text-centered">
          <h5 class="title is-5">Salary Increases</h5>
        </div>
        <div class="box">
          <p>How much do you expect your annual salary to increase each year? Annual statement values are based upon the assumption that you will receive a 1.5% annual salary increase.</p>
          <br>
          <div class="container">
            <div class="field is-grouped">
              <div class="field-label">
                <label class="label">Percent Increase</label>
              </div>
              <p class="control is-expanded">
                <b-select placeholder="% Incr." name="perIncrease" v-model="calcData.perIncrease" required>
                  <option value="0.0" selected="selected">0.0%</option>
                  <option value="0.5">0.5%</option>
                  <option value="1.0">1.0%</option>
                  <option value="1.5">1.5%</option>
                  <option value="2.0">2.0%</option>
                  <option value="2.5">2.5%</option>
                  <option value="3.0">3.0%</option>
                  <option value="3.5">3.5%</option>
                  <option value="4.0">4.0%</option>
                  <option value="4.5">4.5%</option>
                  <option value="5.0">5.0%</option>
                </b-select>
              </p>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
    <br>


    <div class="container">
      <div class="box">
        <div class="content has-text-centered">
          <h5 class="title is-5">Service Purchase</h5>
        </div>
        <div class="box">
          <table class="table is-fullwidth">
            <div class="content">

              <tbody>
                <tr>
                  <td width="50%">&nbsp;</td>
                  <td width="25%">Years&nbsp;</td>
                  <td width="25%">Months&nbsp;</td>
                </tr>
                <tr>
                  <td width="50%">Planned Service Credit Purchase</td>
                  <td width="25%">
                    <p class="control is-expanded">
                      <b-input placeholder="Years" id="scYearsPurchase" v-model="calcData.scYearsPurchase" v-on:blur="chkServiceBlank('scy')" type="number" min="0" max="50"></b-input>
                    </p>
                  </td>
                  <td width="25%">
                    <p class="control is-expanded">
                      <b-input placeholder="Months" id="scMonthsPurchase" v-model="calcData.scMonthsPurchase" v-on:blur="chkServiceBlank('scm')" type="number" min="0" max="11"></b-input>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;Planned Membership Service Purchase</td>
                  <td>
                    <p class="control is-expanded">
                      <b-input placeholder="Years" id="msYearsPurchase" v-model="calcData.msYearsPurchase" v-on:blur="chkServiceBlank('msy')" type="number" min="0" max="50"></b-input>
                    </p>
                  </td>
                  <td>
                    <p class="control is-expanded">
                      <b-input placeholder="Months" id="msMonthsPurchase" v-model="calcData.msMonthsPurchase" v-on:blur="chkServiceBlank('msm')" type="number" min="0" max="11"></b-input>
                    </p>
                  </td>
                </tr>
              </tbody>
            </div>
          </table>
        </div>
      </div>
    </div>
    <!-- ======================== -->
    <br>
  </form>

  <section>
    <div class="container">
        <b-message id="msg-bottom" type="is-danger" style="display: none">
          <li v-for="message in messages">
            {{ message }}
          </li>
        </b-message>
    </div>
  </section>


  <section class="section">
    <div class="columns">
      <div class="column">
        <b-field horizontal>
          <button class="button" id="prevButton" v-on:click="gotoPage1()">
            <b-icon icon="arrow-left-bold"></b-icon>
            <span>Previous</span>
          </button>
        </b-field>
      </div>
      <div class="column">
      </div>
      <div class="column">
      </div>
      <div class="column">
        <b-field horizontal>
          <button class="button" id="nextButton" v-on:click="processPage2()">
            <span>Get Estimate</span>
            <b-icon icon="arrow-right-bold"></b-icon>
          </button>
        </b-field>

      </div>
    </div>
  </section>
</div>
</template>

<script>
export default {
  name: "Page02",
  data: function() {
    return {
      errMessag: "PAGE 2 message",
      messages: []
    }
  },
  props: ["calcData"],
  computed: {
    scDecimalPurchase: function() {
      var m = 0
      var y = 0
      var d = 0
      y = parseInt(this.calcData.scYearsPurchase)
      m = parseInt(this.calcData.scMonthsPurchase)
      d = (y * 12) + m
      return d
    },
    msDecimalPurchase: function() {
      var m = 0
      var y = 0
      var d = 0
      if (this.calcData.msYearsPurchase == "") {
        this.calcData.msYearsPurchase = 0
      }
      if (this.calcData.msMonthsPurchase == "") {
        this.calcData.msMonthsPurchase = 0
      }
      y = parseInt(this.calcData.msYearsPurchase)
      m = parseInt(this.calcData.msMonthsPurchase)
      d = (y * 12) + m
      return d
    },
  },
  methods: {

// ===========  check purchased fields     ==================================================================================================
    chkServiceBlank: function(inFlag) {
      var top_msgElement = document.getElementById("msg-top")
      var bottom_msgElement = document.getElementById("msg-bottom")
      top_msgElement.style.display = "none"
      bottom_msgElement.style.display = "none"

      switch (inFlag) {
        case "scy":
          var scYearsElement = document.getElementById("scYearsPurchase")
          scYearsElement.classList.remove("is-danger");
          if (!this.calcData.scYearsPurchase) {
            this.calcData.scYearsPurchase = 0
          }
          break;
        case "scm":
          var scMonthsElement = document.getElementById("scMonthsPurchase")
          scMonthsElement.classList.remove("is-danger");
          if (!this.calcData.scMonthsPurchase) {
            this.calcData.scMonthsPurchase = 0
          }
          break;
        case "msy":
          var msYearsElement = document.getElementById("msYearsPurchase")
          msYearsElement.classList.remove("is-danger");
          if (!this.calcData.msYearsPurchase) {
            this.calcData.msYearsPurchase = 0
          }
          break;
        case "msm":
          var msMonthsElement = document.getElementById("msMonthsPurchase")
          msMonthsElement.classList.remove("is-danger");
          if (!this.calcData.msMonthsPurchase) {
            this.calcData.msMonthsPurchase = 0
          }
          break;
        default:
          alert("other")
      }
    },


//============================================================================================
//==  Calculate years to retirement using 'at' termination date
//============================================================================================
    // pass in in_termDate as a 'Date' variable
    calcYearsToRetirement_Term: function(in_termDate) {
      var today = new Date();
      var effDelta = this.get_years_diff(in_termDate,today);
      return(effDelta);
    },
    // pass in variables as date types
    get_years_diff: function(in_date1,in_date2) {
        var numOfMiliSecondsInYear = 1000 * 365.25 * 24 * 60 * 60;
        var seconds1 = Date.parse(in_date1);
        var seconds2 = Date.parse(in_date2);
        var yrs = (seconds1-seconds2) / numOfMiliSecondsInYear;
        // alert("'A' yrstoret: " + yrs);
        return yrs;
      },

//============================================================================================
//==  Calculate years to retirement using 'at' Age
//============================================================================================
      calcYearsToRetirement_Age: function(in_AgeAt,in_membAge) {
        var effDelta = parseFloat(in_AgeAt) - parseFloat(in_membAge)
        if (effDelta < 1) {
          effDelta = 0
        }
        // alert("'A' effDelta: " + effDelta);
        return(effDelta)
      },

//============================================================================================
//==  Calculate years to retirement using 'at' Serv. Credit Years
//============================================================================================
      calcYearsToRetirement_SC: function(in_SCYears,in_TotalServCredit) {
        var effDelta = parseFloat(in_SCYears) - parseFloat(in_TotalServCredit)
        if (effDelta < 1) {
          effDelta = 0;
        }
        // alert("'SC' effDelta: " + effDelta);
        return(effDelta);
      },

// ===========  Get Option Factor    ==================================================================================================
    getFactorFetch: function(inRetOption,inMbrAge,inBeneAge,inGaba) {
      debugger;

      var strURL = "http://10.192.164.76/getoptionfactor.php?opt='" + inRetOption + "'&ma=" + inMbrAge + '&ba=' + inBeneAge + '&g=' + inGaba;
      // alert (strURL)
      var optFactor = 0
      var Httpreq = new XMLHttpRequest()
      Httpreq.open("GET",strURL,false)
      Httpreq.send(null)
      var myObj = JSON.parse(Httpreq.responseText)
      return myObj.factor
    },

    // ===========  Get ERF  ==================================================================================================


        getERF_Factor: function(inMbrAge,inMbrServ,inGaba,inPrePost2011) {
          debugger;
          var strURL = "http://10.192.164.76/getERFfactor.php?ma=" + inMbrAge + "&ms=" + parseInt(inMbrServ) + '&g=' + inGaba + '&pp=' + inPrePost2011
          // alert (strURL)
          // $inMbrAge = htmlspecialchars($_GET["ma"]);
          // $inMbrServ = htmlspecialchars($_GET["ms"]);
          // $inGABA  = htmlspecialchars($_GET["g"]);
          // $inPreOrPost2011  = htmlspecialchars($_GET["pp"]);

          // alert (strURL)
          var Httpreq = new XMLHttpRequest()
          Httpreq.open("GET",strURL,false)
          Httpreq.send(null)
          var myObj = JSON.parse(Httpreq.responseText)
          return myObj.factor
        },

    gotoPage1: function(event) {
      this.$router.push('/home')
    },

//***************************
isEligible: function(inTotalMembServ,inAge,inDateHired) {
  debugger
  var compareDate = new Date('2011-07-01 00:00:00')
  if (inDateHired < compareDate) {
    return this.pre2011(inTotalMembServ,inAge);
  }
  else {
    return this.post2011(inTotalMembServ,inAge);
  }
},
//***************************
pre2011: function(inTotalMembServ,inAge){
  if (inAge >= 65) {
    return 'R';  // (R)egular
  }
  else {
    if (inTotalMembServ >= 30) {
      return 'R';  // (R)egular
    }
    else {
      if (inTotalMembServ >= 5 && inAge >= 60) {
        return 'R';  // (R)egular
      }
      else {
        if ((inTotalMembServ >= 5 && inAge >= 50) || (inTotalMembServ >=25)) {
          return 'E';  // (E)arly
        }
        else {
          return 'N';  // (N)ot Eligible
        }
      }
    }
  }  // end of if > 65
}, // end of function
//***************************
post2011: function(inTotalMembServ,inAge){
  if (inAge >= 70) {
    return 'R';
  }
  else {
    if (inTotalMembServ >= 5 && inAge >= 65) {
      return 'R';
    }
    else {
      if (inTotalMembServ >= 5 && inAge >= 55) {
        return 'E';
      }
      else {
        return 'N';
      }
    }
  }
}, // end of function
//***************************


    processPage2: function(event) {
      var top_msgElement = document.getElementById("msg-top")
      var bottom_msgElement = document.getElementById("msg-bottom")
      var memberdobElement = document.getElementById("memberdob")
      var benedobElement = document.getElementById("benedob")

      var localMessages = []
      var editsPassed = true
      var today = new Date()

      top_msgElement.style.display = "none"
      bottom_msgElement.style.display = "none"


// ===========  MEMBER DOB EDIT    ==================================================================================================
      if (!this.calcData.memberdob) {    //  -- check for empty/null/etc
        editsPassed = false
        memberdobElement.classList.add("is-danger");
        localMessages.push("Please Enter Member's Birth Date")
      } else {
        memberdobElement.classList.remove("is-danger");
      }

// ===========  CONT. ANNUITANT DOB EDIT    ==================================================================================================
      // if (this.calcData.retsys === 'PERS') {     //  -- this edit only applies if PERS
      //   if (!this.calcData.benedob) {           //  -- check for empty/null/etc
      //     editsPassed = false
      //     benedobElement.classList.add("is-danger");
      //     localMessages.push("Please Enter Contingent Annuitant's Birth Date")
      //   } else {
      //     benedobElement.classList.remove("is-danger");
      //   }
      // }

// ===========  Check Term Info    ==================================================================================================
      var at_termElement = document.getElementById("term")
      var at_ageElement = document.getElementById("at_age")
      var at_scyearsElement = document.getElementById("at_scyears")
      switch (this.calcData.checkedOption) {
        case 'T':
          if (!this.calcData.at_termdate) {           //  -- check for empty/null/etc
            editsPassed = false
            at_termElement.classList.add("is-danger");
            localMessages.push("Please Enter Termination Date")
          } else {
            at_termElement.classList.remove("is-danger");
          }
          break;
          case 'A':
            if (!this.calcData.at_age) {           //  -- check for empty/null/etc
              editsPassed = false
              at_ageElement.classList.add("is-danger");
              localMessages.push("Please Enter Age at Retirement")
            } else {
              at_ageElement.classList.remove("is-danger");
            }
            break;
            case 'Y':
              if (!this.calcData.at_scyears) {           //  -- check for empty/null/etc
                editsPassed = false
                at_scyearsElement.classList.add("is-danger");
                localMessages.push("Please Enter Years of Service Credit")
              } else {
                at_scyearsElement.classList.remove("is-danger");
              }
              break;
        default:

      }




// ===========  Check if edits have passed    ==================================================================================================

//=================================  DID pass edits ====================================

      if (editsPassed) {
        this.calcData.memberage = this.get_age(this.calcData.memberdob,today)
        if (!this.calcData.benedob) {
          this.calcData.beneage = 0
        } else {
          this.calcData.beneage = this.get_age(this.calcData.benedob,today)
        }


        this.calcData.totServCredit=parseInt(this.calcData.scYears) + parseInt(this.calcData.scYearsPurchase) + ((parseInt(this.calcData.scMonths) + parseInt(this.calcData.scMonthsPurchase)) / 12 )
        this.calcData.totMembServ=parseInt(this.calcData.msYears) + parseInt(this.calcData.msYearsPurchase) + ((parseInt(this.calcData.msMonths) + parseInt(this.calcData.msMonthsPurchase)) / 12 )

        this.calcData.scDecimal = ((parseFloat(this.calcData.scYears) * 12) + parseFloat(this.calcData.scMonths)) / 12
        this.calcData.msDecimal = ((parseFloat(this.calcData.msYears) * 12) + parseFloat(this.calcData.msMonths)) / 12

        this.calcData.scDecimalPurchase = ((parseFloat(this.calcData.scYearsPurchase) * 12) + parseFloat(this.calcData.scMonthsPurchase)) / 12
        this.calcData.msDecimalPurchase = ((parseFloat(this.calcData.msYearsPurchase) * 12) + parseFloat(this.calcData.msMonthsPurchase)) / 12

        switch (this.calcData.checkedOption) {
          case 'T':
            this.calcData.yearsToRet = this.calcYearsToRetirement_Term(this.calcData.at_termdate);
            this.calcData.retDate = this.calcData.at_termdate
            // alert ("years to ret (T): " + this.calcData.yearsToRet)
            break;
          case 'A':
            this.calcData.yearsToRet = this.calcYearsToRetirement_Age(this.calcData.at_age,this.calcData.memberage);
            var d = new Date();
            var year = d.getFullYear();
            var month = d.getMonth();
            var day = d.getDate();
            this.calcData.retDate = new Date(year + parseInt(this.calcData.yearsToRet), month, day)
            // (in_AgeAt,in_membAge)
            break;
          case 'Y':
            this.calcData.yearsToRet = this.calcYearsToRetirement_SC(this.calcData.at_scyears,this.calcData.totServCredit);
            var d = new Date();
            var year = d.getFullYear();
            var month = d.getMonth();
            var day = d.getDate();
            this.calcData.retDate = new Date(year + parseInt(this.calcData.yearsToRet), month, day)
            break;
          default:
            alert ("error occured");
        }
        // alert ("Years to Ret: " + this.calcData.yearsToRet)

        this.calcData.totServCredit=this.calcData.totServCredit + parseFloat(this.calcData.yearsToRet)
        this.calcData.totMembServ=this.calcData.totMembServ + parseFloat(this.calcData.yearsToRet)

        this.calcData.memberage_at_ret = this.calcData.memberage + parseInt(this.calcData.yearsToRet)
        if (this.calcData.beneage == 0) {
          this.calcData.beneage_at_ret = 0
        } else {
          this.calcData.beneage_at_ret = this.calcData.beneage + parseInt(this.calcData.yearsToRet)
        }

        this.calcData.hac = this.calcHAC(this.calcData.annsalary,this.calcData.perIncrease,this.calcData.yearsToRet)


        var hireEffDate = new Date('2011-07-01 00:00:00')
        if (this.calcData.hiredate <  hireEffDate) {
          if (this.calcData.totMembServ >= 25) {
            //  PRE 2011: 02 (MS Years >= 25)
            this.calcData.muliplier = .02
          } else {
            // PRE 2011: 017857 (MS Years < 25)
            this.calcData.muliplier = .017857
          }
        } else {
            if ((this.calcData.totMembServ) >= 5 && (this.calcData.totMembServ) < 10 ) {
              // post 2011: 015 (MS Years >= 5 and < 10)
              this.calcData.muliplier = .015
            }
            else if ((this.calcData.totMembServ) >= 10 && (this.calcData.totMembServ) < 30 ) {
              // post 2011: 017857  (MS Years >= 10 and < 30)
              this.calcData.muliplier = .017857
            }
            else {
              // post 2011: 02 (MS Years > 30)
              this.calcData.muliplier = .02
            }
          }
          // alert ("multiplier: " + this.calcData.muliplier)

        ///----------------------- Calculate Benefit  ---------------------------


        if (this.calcData.totMembServ < 5) {
          localMessages.push("Less than 5 years Membership Service (" + this.calcData.totMembServ.toFixed(2) + "), not eligible for a benefit")
          this.messages = localMessages
          top_msgElement.style.display = "block"
          bottom_msgElement.style.display = "block"

        } else {
          top_msgElement.style.display = "none"
          bottom_msgElement.style.display = "none"

          var eligibility = this.isEligible(this.calcData.totMembServ,this.calcData.memberage_at_ret,this.calcData.hiredate)
          // alert ("eligibility: " + eligibility)

          var erf = 0

          switch (eligibility) {
            case 'E':
              var compareDate = new Date('2011-07-01 00:00:00')
              if (this.calcData.hiredate < compareDate) {
                erf = this.getERF_Factor(this.calcData.memberage_at_ret,this.calcData.totMembServ,3,'PRE')
              } else {
                erf = this.getERF_Factor(this.calcData.memberage_at_ret,this.calcData.totMembServ,3,'POST')
              }
              this.calcData.retTypeDescription = 'EARLY RETIREMENT ESTIMATE'
              // alert ("erf: " + erf)
              break;
            case 'R':
              erf = 1;
              this.calcData.retTypeDescription = 'REGULAR RETIREMENT ESTIMATE'
              break;
            case 'N':
              erf = 1;
              break
            default:
              alert ("Invalid eligibilty")
          }
          this.calcData.erf = erf
          this.calcData.opt1 = ((this.calcData.muliplier * this.calcData.totServCredit * this.calcData.hac) / 12) * erf
          this.calcData.opt2 = ((this.calcData.muliplier * this.calcData.totServCredit * this.calcData.hac * this.getFactorFetch("OPT2",this.calcData.memberage_at_ret,this.calcData.beneage_at_ret,"3")) / 12) * erf
          this.calcData.opt3 = ((this.calcData.muliplier * this.calcData.totServCredit * this.calcData.hac * this.getFactorFetch("OPT3",this.calcData.memberage_at_ret,this.calcData.beneage_at_ret,"3")) / 12) * erf
          this.calcData.opt410 = ((this.calcData.muliplier * this.calcData.totServCredit * this.calcData.hac * this.getFactorFetch("OPT410",this.calcData.memberage_at_ret,0,"3")) / 12) * erf
          this.calcData.opt420 = ((this.calcData.muliplier * this.calcData.totServCredit * this.calcData.hac * this.getFactorFetch("OPT420",this.calcData.memberage_at_ret,0,"3")) / 12) * erf
          var strMssg = "Opt1: " + this.calcData.opt1 + "\r\n"
          strMssg = strMssg + "Opt2: " + this.calcData.opt2 + "\r\n"
          strMssg = strMssg + "Opt3: " + this.calcData.opt3 + "\r\n"
          strMssg = strMssg + "Opt410: " + this.calcData.opt410 + "\r\n"
          strMssg = strMssg + "Opt420: " + this.calcData.opt420 + "\r\n"
          // alert (strMssg)

          ///----------------------- GO TO Estimate Page  ---------------------------

          this.$router.push('EstimatePage')
        }


///=================================  Did NOT pass edits ====================================

      } else {
        top_msgElement.style.display = "block"
        bottom_msgElement.style.display = "block"
      }
      this.messages = localMessages
    },  //   END OF ProcessPage1 Method  <<<<<<<<<<<<<<<<<<<<<<<<<<<<



///-------------------------------    Misc. functions  ---------------------------


//=================================  Calc HAC  ====================================
calcHAC: function(inAnnSal,inPercentIncrease,inYearsToRetirement) {
  inAnnSal = parseFloat(inAnnSal)
  inPercentIncrease = parseFloat(inPercentIncrease)
  inYearsToRetirement = parseFloat(inYearsToRetirement)
  // alert ("Per Inc -  Annsal - Years to Ret : " + this.calcData.perIncrease + " - " + inAnnSal + " - " + inYearsToRetirement)
  var SalaryArray = new Array()
  var i = 0
  if (inPercentIncrease < .5 || inYearsToRetirement < 1) {
    return inAnnSal;
  }
  else {
    inPercentIncrease = inPercentIncrease / 100;
      // echo "PerIncr: " . $inPercentIncrease . "<br>";
      SalaryArray[0] = inAnnSal;
      // echo "Array(0) - " . $SalaryArray[0] . "<br>";
      for (i=1; i<= inYearsToRetirement; i++) {
          SalaryArray[i] = (SalaryArray[i-1] * inPercentIncrease) + SalaryArray[i-1];
          // echo "Array(" . $i . ") - " . $SalaryArray[$i] . "<br>";
      }
      var HAC = (SalaryArray[inYearsToRetirement] + SalaryArray[inYearsToRetirement-1] + SalaryArray[inYearsToRetirement-2]) / 3;
      return HAC;
    }
},

//=================================  Get Age  ====================================

    get_age: function(in_dob,in_date) {
    // pass in variables as ???
          var birthDate = in_dob;
          var year_1 = in_date.getFullYear();
          var year_2 = birthDate.getFullYear();
          var age = year_1 - year_2;
          var month_1 = in_date.getMonth();
          var month_2 = birthDate.getMonth();
          var m = month_1 - month_2;
          if (m < 0 || (m === 0 && in_date.getDate() < birthDate.getDate())) {
              age--;
          }
          return age;
      },

      get_years_diff: function(in_date1,in_date2) {
      // pass in variables as date types
          var numOfMiliSecondsInYear = 1000 * 365.25 * 24 * 60 * 60;
          // if (in_date1  < in_date2) {
            // var wrkDate1 = in_date1;
            // var wrkDate2 = in_date2;
          // } else {
          //   var wrkDate1 = in_date2;
          //   var wrkDate2 = in_date1;
          // }
          var seconds1 = Date.parse(in_date1);
          var seconds2 = Date.parse(in_date2);
          var age = (seconds1-seconds2) / numOfMiliSecondsInYear;
          return age;
        }
  },
};
</script>
